import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import styled from 'styled-components';
import config from '../../../config/app';
import {isPdf} from '../../../utils';
import Image from '../../../common/components/Image';

const PdfReceipt = styled.object`
  height: 100%;
  width: 100%;
  object-fit: contain;
  min-height: 500px;
`;

const ImageReceipt = styled(Image)`
  width: 100%;
  object-fit: contain;
  max-height: 500px;
`;

const TicketPreview = ({t, receipt}) => {
  return isPdf(receipt.file) ? (
    <PdfReceipt
      data={config.api_file_receipt + receipt.id + '?token=' + receipt.file.token} type="application/pdf">
      {t('errorDisplaying')}
    </PdfReceipt>
  ) : (
    <ImageReceipt
      src={config.api_file_receipt + receipt.id + '?token=' + receipt.file.token}/>
  );
};

TicketPreview.propTypes = {
  t: PropTypes.func.isRequired,
  receipt: PropTypes.shape({
    id: PropTypes.string.isRequired,
    file: PropTypes.shape({
      token: PropTypes.string.isRequired,
      mimeType: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default withTranslation('ticket')(TicketPreview);
